// extracted by mini-css-extract-plugin
export default {"articleContent":"Article_articleContent__MF2n7","section2":"Article_section2__ygb0o","articleSection":"Article_articleSection__-JFsk","section1":"Article_section1__DP3aS"};